import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CampaignStepEntity } from '../../domain/entities/CampaignStepEntity'
import type { DiscountAppliedTo, DiscountType } from '@/backend/market'
import { CampaignBranchModel } from './CampaignBranchModel'

export class CampaignStepModel extends CampaignStepEntity {
  loyaltyProgramBonus?: {
    bonusPoints?: number
    bonusMultiplier?: number
    isActive?: boolean
  }
  declare index: number
  declare type: DiscountType
  declare value: number
  declare maxDiscountAllowed: number
  declare defaultServiceRatio: number
  declare defaultBranchRatio: number
  declare limitedDefaultBranchShareAmount?: number | null
  declare appliedTo: DiscountAppliedTo
  declare minCartAmount: number
  declare branches?: Array<CampaignBranchModel> | null

  constructor(dataDto: CampaignStepEntity) {
    super()
    mapEntityProperties<CampaignStepModel>(this, dataDto, {
      map: {
        loyaltyProgramBonus: dataDto.bonusPoints
          ? {
              bonusPoints: dataDto.bonusPoints,
              bonusMultiplier: dataDto.bonusMultiplier,
              isActive: dataDto.isActive
            }
          : undefined,
        branches: dataDto.branches?.map((branchData) => new CampaignBranchModel(branchData))
      }
    })
  }
}
